<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
            <select v-model="showing">
                <option value="9">Top 10</option>
                <option value="4">Top 5</option>
                <option value="2">Top 3</option>
                <option value="all" selected>Show All</option>
            </select>
            <chart :options="chartOptions"  ref="chart"></chart>
            <span>Total de rides:{{totalRides}}</span>
        </b-overlay>

    </section>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import api from '../../../../../api.js'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    exportingInit(Highcharts)

    export default {
        name: "RevenuePerStatus",
        components:{Chart},
        props: {
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
            let seriesExample = [{
                name:"",
                data:[]
            }];
            return {
                currency:"",
                totalRides:0,
                showing:"all",
                originalCategories:[],
                originalSeries:[],
                loading:false,
                exporting: {
                    enabled: true
                },
                codeReport : "revenue-per-status",
                chartOptions:{
                    title: {
                        text: 'Revenue por Estatus'
                    },
                    tooltip: {
                        formatter: function(tooltip) {
                            let original = tooltip.defaultFormatter.call(this, tooltip);
                            let detalle   = this.point.details??{};
                            for (let status in detalle ){
                                original.push(status+"= <b>"+detalle[status]+"</b><br/>");
                            }
                            return original;
                        }
                    },
                    yAxis: {
                        title: {
                            text: '$'
                        }
                    },
                    exporting:{
                        buttons:{
                            menuItems:["viewFullscreen"]
                        }
                    },
                    chart:{
                        type:''
                    },
                    xAxis:{
                        type: 'category',
                        categories:[],
                        max:null,
                    },
                    series: seriesExample
                }
            }
        },
        methods:{
            fetchDataChart(){
                this.loading=true;
                api(this).get(`/dashboard/comercial/charts/${this.codeReport}`,{params: {filters:this.filters}}).then((res) => {
                    this.currency           = res.data.currency;
                    this.totalRides         = res.data.totalRides;
                    this.originalCategories = res.data.categories;
                    this.originalSeries     = res.data.series;
                    this.chartOptions.series               = res.data.series;
                    this.chartOptions.xAxis.categories     = res.data.categories;
                    this.chartOptions.yAxis.title.text     = "$ "+this.currency.toUpperCase();
                }).catch(this.$root.handleRequestError).finally(()=>{
                    this.loading=false;
                    this.$emit('finished');
                })
            },
        },
        watch:{
            showing(){
                if(this.showing >0 ){
                    if((this.showing)<= (this.chartOptions.xAxis.categories.length-1) ){
                        this.chartOptions.xAxis.max= this.showing;
                    }else{
                        this.showing = 'all';
                    }
                }else{
                    this.chartOptions.xAxis.max = null;
                }
            },
            triggerSearch(){//este valor es reactivo, el padre decide en que momento se dispara la busqueda
                this.fetchDataChart();
            }
        },
        mounted() {
            if(this.triggerSearch>0){
                this.fetchDataChart();
            }
        }
    }
</script>

<style scoped>

</style>